/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryTestingList(_, data) {
      return await api.post(`/api/testing/getLists`, data);
    },
    async queryBrandList(_, data) {
      return await api.post(`/api/enterprise/getServiceLists`, data);
    },
  },
}
